import PropTypes from 'prop-types';
import Link from '@/components/Link';

const defaultProps = {};

const propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default function CertificationTitle({
  title,
  url,
}) {
  return (
    <Link href={url} title={`Más información sobre ${title}`}>
      <h2 className="text-lg md:text-2xl font-semibold tracking-tight">
        {title}
      </h2>
    </Link>
  );
}

CertificationTitle.defaultProps = defaultProps;
CertificationTitle.propTypes = propTypes;
